import { render, staticRenderFns } from "./page-header-breadcrumbs.vue?vue&type=template&id=4973d60a&"
import script from "./page-header-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./page-header-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./page-header-breadcrumbs.vue?vue&type=style&index=0&id=4973d60a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports